"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _isNil = _interopRequireDefault(require("lodash/isNil"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var PostfixIconWrapper = function PostfixIconWrapper(_ref) {
  var className = _ref.className,
    onClick = _ref.onClick,
    children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(StyledIconWrapper, {
    className: className,
    onClick: onClick
  }, children);
};
var StyledIconWrapper = _styledComponents["default"].div.withConfig({
  displayName: "PostfixIconWrapper__StyledIconWrapper",
  componentId: "sc-cj7mkh-0"
})(["padding-right:7px;display:inline-flex;", ""], function (_ref2) {
  var onClick = _ref2.onClick;
  return !(0, _isNil["default"])(onClick) && (0, _styledComponents.css)(["cursor:pointer;"]);
});
var _default = exports["default"] = PostfixIconWrapper;